import { render, staticRenderFns } from "./CustomerTrainingResourcesLink.vue?vue&type=template&id=444799f0&"
import script from "./CustomerTrainingResourcesLink.vue?vue&type=script&lang=js&"
export * from "./CustomerTrainingResourcesLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports